import { createContext } from 'react';

import { AppContextProps } from '@models/appContextProps';

import InitialAppContext from './initialState';

const AppContext = createContext<AppContextProps>({
  state: InitialAppContext,
  dispatch: () => null
});

export default AppContext;
